import ConditionalHeadingComponent from './conditional-heading-component.js';

export const ConditionalHeadingControl = wp.customize.KadenceControl.extend( {
	renderContent: function renderContent() {
		let control = this;
		ReactDOM.render( <ConditionalHeadingComponent control={ control } customizer={ wp.customize } />, control.container[0] );
	}
} );
